import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-29",
  "use": "icon-icon-nav-29-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-29\"><path d=\"M370.112 249.792l-45.888-45.888A334.592 334.592 0 0 0 192 455.808h64.192a271.04 271.04 0 0 1 113.92-206.08z m397.696 206.08H832a336.64 336.64 0 0 0-132.224-251.968l-45.568 45.888a272.64 272.64 0 0 1 113.6 206.08z m-63.232 16c0-98.56-52.608-180.992-144.448-202.88v-21.76a48.064 48.064 0 1 0-96.256 0v21.76c-92.16 21.888-144.448 104-144.448 202.88v160.512l-64.192 64.192v32.064h513.536v-32.064L704.576 632.32V471.872zM512 824.96a65.152 65.152 0 0 0 59.072-39.168c3.2-7.68 4.8-16 4.8-25.024H447.488A64.64 64.64 0 0 0 512 824.96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-29.svg
// module id = 7+bK
// module chunks = 3